export class Result<T> {
    data: T;
    metadata: Object
    success: boolean;
    error: string;

    constructor(data: T, metadata) {
        this.data = data;
        this.metadata = metadata;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Result.model.ts